import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import {
  Buttons_Styles,
  Card_Styles,
  Cards_Types,
  Choices_Styles,
  DropDown_Styles,
  Field_Text_Styles,
  Field_date_time_Styles,
  MENU_BUTTON_FORM,
  c1,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";

@Component({
  selector: "app-button-position-component",
  templateUrl: "./button-position-component.component.html",
  styleUrls: ["./button-position-component.component.scss"],
})
export class ButtonPositionComponentComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService
  ) {}

  @Input() button_id: string;
  @Input() config: any;
  mode: string;

  // default values
  icon: string;
  offCanvasSubscription: any;
  offcanvasColors = offcanvasColors;
  button: MenuButton;
  data: any;
  currentMenuSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  isAndroid: boolean;
  text_id: any;
  buttonFormTypes: typeof MENU_BUTTON_FORM = MENU_BUTTON_FORM;
  labelform: UntypedFormGroup;

  stylesChoices = [];
  card_types = [];
  sync = true;

  ngOnInit() {
    this.field_id = "label";
    this.labelform = this.formBuilder.group({
      position: new UntypedFormControl("single"),
    });
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      }
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
          this.icon;
          this.buttonFunction();
        }
      }
    );
  }

  buttonIntialize(data) {
    this.data = data.data;
    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    if (this.button) {
      this.text_id = this.config.id.split(/_(.*)/s)[1];
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;

      this.labelform = this.formBuilder.group({
        position: new UntypedFormControl(
          this.isAndroid &&this.button.button_position ? this.button.button_position :!this.isAndroid &&this.button.button_position_ios ? this.button.button_position_ios : "single"
        ),
      });
    }
  }

  changePosition() {
    if(this.isAndroid || this.sync){
      this.button.button_position = this.labelform.value.position;
    }
    if(!this.isAndroid || this.sync){
      this.button.button_position_ios = this.labelform.value.position;
    }
    this.updateButtonData();
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true
    );
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
  }
}
